import { OverlayTrigger, Table, Tooltip, Pagination } from "react-bootstrap";
import { DollarSign, UserCheck } from "react-feather";
import { formatNumberWithCommas } from "../../../../utils/utility";

export default function TransactionsList({
    transaction = [],
    onAssignSalesperson,
    currentPage = 1,
    perPage = 0,
    lastPage = 1, // total pages from API
    onPageChange,
}) {
    const handlePageChange = (page) => {
        if (page >= 1 && page <= lastPage) {
            onPageChange(page);
        }
    };

    const renderPagination = () => {
        if (!Number.isFinite(lastPage) || lastPage <= 1) return null;

        const pageNumbers = Array.from({ length: lastPage }, (_, i) => i + 1);

        return (
            <Pagination className="justify-content-end mt-3 mb-0">
                <Pagination.Prev
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                />
                {pageNumbers.map((num) => (
                    <Pagination.Item
                        key={num}
                        active={num === currentPage}
                        onClick={() => handlePageChange(num)}
                    >
                        {num}
                    </Pagination.Item>
                ))}
                <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === lastPage}
                />
            </Pagination>
        );
    };

    // Sticky style for table headers
    const stickyHeaderStyle = {
        position: "sticky",
        top: "3rem", // adjust if top pagination height changes
        background: "#fff",
        zIndex: 2,
    };

    return (
        <div style={{ position: "relative" }}>
            {/* Top Pagination */}
            <div
                style={{
                    position: "sticky",
                    top: 0,
                    background: "#fff",
                    zIndex: 3,
                    padding: "0.5rem 0",
                }}
            >
                {renderPagination()}
            </div>

            {/* Table */}
            <Table striped bordered hover>
                <thead className="table-light">
                    <tr>
                        {[
                            "S.No",
                            "Actions",
                            "Transaction ID",
                            "Payment Date",
                            "Payment Time",
                            "Remarks",
                            "Amount",
                            "Remaining Amount",
                            "Invoice Number",
                            "Paid Invoice",
                            "Company",
                            "Sales Person",
                            "Submitted Date",
                            "Status",
                        ].map((text, idx) => (
                            <th key={idx} style={stickyHeaderStyle}>
                                {text}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {transaction.length === 0 ? (
                        <tr>
                            <td colSpan={15} className="text-center">
                                No data available
                            </td>
                        </tr>
                    ) : (
                        transaction.map((data, index) => (
                            <tr key={data.id ?? index}>
                                <td>
                                    {(currentPage - 1) * perPage + index + 1}
                                </td>
                                <td>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>Invoice Payment</Tooltip>
                                        }
                                    >
                                        <a
                                            href={`/tms/bank-transactions/payment/${data.id}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="me-1"
                                        >
                                            <DollarSign
                                                size={18}
                                                color="#6c757d"
                                            />
                                        </a>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>
                                                Assign Sales Person
                                            </Tooltip>
                                        }
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-link p-0 me-1"
                                            onClick={() =>
                                                onAssignSalesperson(data)
                                            }
                                        >
                                            <UserCheck
                                                size={18}
                                                color="#6c757d"
                                            />
                                        </button>
                                    </OverlayTrigger>
                                </td>
                                <td>{data.reference_number || "-"}</td>
                                <td className="text-nowrap">{data.date || "-"}</td>
                                <td className="text-nowrap">{data.time || "-"}</td>
                                <td>{data.remarks || "-"}</td>

                                <td>
                                    ${formatNumberWithCommas(data.amount ?? 0)}
                                </td>
                                <td>
                                    $
                                    {formatNumberWithCommas(
                                        data.remaining_amount ?? 0
                                    )}
                                </td>
                                 <td>
                                    {data.invoice ? (
                                        <a
                                            href={`/tms/bank-transactions/payment/${data.id}?company_id=${data.invoice.company_id}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{
                                                color: "#2563EB",
                                                textDecoration: "underline",
                                            }}
                                        >
                                            {data.invoice_number}
                                        </a>
                                    ) : (
                                        data.invoice_number || "-"
                                    )}
                                </td>
                                <td style={{ whiteSpace: "nowrap" }}>
                                    {data?.paid_invoice?.length
                                        ? data.paid_invoice.map((inv, idx) => (
                                              <span
                                                  key={idx}
                                                  style={{
                                                      color: inv.payment_alert
                                                          ? "red"
                                                          : "inherit",
                                                      marginRight: "8px",
                                                  }}
                                              >
                                                  {inv.number} (
                                                  {Number(inv.amount).toFixed(
                                                      2
                                                  )}
                                                  )
                                              </span>
                                          ))
                                        : "-"}
                                </td>
                                <td>{data.unique_companies || "-"}</td>
                                <td>{data.salesperson?.name || "-"}</td>
                                <td>{data.submitted_date || "-"}</td>
                                <td>{data.status || "-"}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>

            {/* Bottom Pagination */}
            <div
                style={{
                    position: "sticky",
                    bottom: 0,
                    background: "#fff",
                    zIndex: 3,
                    padding: "0.5rem 0",
                }}
            >
                {renderPagination()}
            </div>
        </div>
    );
}
